import { currentlyPlaying } from "../../data/hobbies";
import "./GamesPanel.css";

export default function GamesPanel() {
	return (
		<aside className="gp" aria-label="Currently playing">
			<div className="gp-label mono">NOW PLAYING</div>
			<div className="gp-list">
				{currentlyPlaying.map((game, i) => (
					<div className="gp-item" key={game.id}>
						<div className="gp-item__header">
							<span className="gp-item__num mono">
								{String(i + 1).padStart(2, "0")}
							</span>
						</div>
						<div className="gp-item__title">{game.title}</div>
						<div className="gp-item__stage">
							<span className="gp-item__cursor" aria-hidden="true">
								■
							</span>
							<span className="gp-item__meta mono">
								{game.platform} · {game.status}
							</span>
						</div>

						<div className="gp-corner gp-corner--tl" aria-hidden="true" />
						<div className="gp-corner gp-corner--tr" aria-hidden="true" />
						<div className="gp-corner gp-corner--bl" aria-hidden="true" />
						<div className="gp-corner gp-corner--br" aria-hidden="true" />
					</div>
				))}
			</div>
		</aside>
	);
}
